export default __webpack_public_path__ + "7d2df29b370edc8c9deda1641141e1d2.png";